import { FC, ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { ButtonProps } from '@mui/material/Button';
import { SubmitButton, SubmitButtonProps } from './SubmitButton';

type CustomButtonProps = {
  label?: string;
  loading?: boolean;
  isSecondary?: boolean;
  isDelete?: boolean;
  iconStart?: ReactNode;
} & ButtonProps &
  SubmitButtonProps;

/**
 * @returns Element PrimaryButton
 */
export const ButtonCustom: FC<CustomButtonProps> = ({
  label,
  isDelete,
  isSecondary,
  iconStart,
  ...props
}) => {
  return (
    <PrimaryButtonStyled
      buttondelete={isDelete ? 'isDelete' : ''}
      buttonsecondary={isSecondary ? 'isSecondary' : ''}
      {...props}>
      <>
        {iconStart && iconStart}
        {label && (
          <Typography fontSize={16} fontWeight={700} color={isSecondary ? '#000' : '#fff'}>
            {label}
          </Typography>
        )}
        {props.children}
      </>
    </PrimaryButtonStyled>
  );
};

/**
 * @returns Element PrimaryButton
 */
export const ButtonOutLine: FC<CustomButtonProps> = ({ label, ...props }) => {
  return (
    <PrimaryButtonOutLine {...props}>
      <>
        {label && (
          <Typography fontSize={16} fontWeight={700} color={'#226AAA'}>
            {label}
          </Typography>
        )}
        {props.children}
      </>
    </PrimaryButtonOutLine>
  );
};

export const ButtonNoOutLine: FC<CustomButtonProps> = ({ label, ...props }) => {
  return (
    <ButtonNoOutLineStyled {...props}>
      <>
        {label && (
          <Typography fontSize={16} fontWeight={700} color={'#226AAA'}>
            {label}
          </Typography>
        )}
        {props.children}
      </>
    </ButtonNoOutLineStyled>
  );
};

const PrimaryButtonStyled = styled(SubmitButton)(
  ({ buttondelete, buttonsecondary }: { buttondelete?: string; buttonsecondary?: string }) => ({
    borderRadius: 10,
    padding: '0 20px',
    width: '100%',
    height: 56,
    background: buttondelete ? 'red' : buttonsecondary ? '#CEE3F5' : '#226AAA',
    '&:hover': {
      backgroundColor: buttondelete ? 'red' : buttonsecondary ? '#CEE3F5' : '#226AAA'
    }
  })
);

const PrimaryButtonOutLine = styled(SubmitButton)(() => ({
  borderRadius: 10,
  padding: '0 20px',
  width: '100%',
  height: 56,
  background: '#fff',
  '&:hover': {
    background: '#fff'
  },
  border: '1px solid #226AAA'
}));
const ButtonNoOutLineStyled = styled(SubmitButton)(() => ({
  borderRadius: 10,
  width: '100%',
  height: 56,
  background: '#fff',
  '&:hover': {
    backgroundColor: '#fff'
  }
}));
